import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import CREATE_COURSE from '../mutations/CREATE_COURSE';

const useCreateCourse = () => {
    const [ createNewCourse ] = useMutation( CREATE_COURSE );

    const createCourse = async ( saveData ) => {
        try {
            const response = await createNewCourse(  { variables: { input: saveData } } );
            const success = response?.data?.result?.id;

            if ( success ) {
                return {
                    success: true,
                    response
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error creating course', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            createCourse
        };
    }, [] );
};

export default useCreateCourse;
